import { mapGetters } from "vuex"
import { PartsService } from "@/services/PartsService"
import { CurrencyService, ShoppingCartService, PartListBuilderService, SettingsService } from "@/services/"
import { themeHelper } from "@/components/mixins";
import { LoadingSpinner } from "@/components";
import { constants } from "@/const"

export default {
    components: {
        LoadingSpinner
    },
    mixins: [themeHelper],
    data() {
        return {
            partDetails: null,
            partList: null,
            removedParts: [],
            ordersDisabledText: "",
            ordersDisabledNewStory: "",
            ordersDisabled: false
        }
    },
    computed: {
        ...mapGetters(["getContentItem", "canSeeContractPrice",
            "canSeeDealerNet", "tenantDetails", "cartSummary",
            "cart", "user", "McfCostCenterId", "billingCurrencyCode",
            "audienceIds", "activeAccountId"]),

        totalPrice() {
            if (this.IsNullOrUndefined(this.partList)) {
                return null;
            }
            var total = 0;
            this.partList.Items.forEach(x => {
                if(this.McfCostCenterId == 3 && this.billingCurrencyCode == "JPY") { // MLAP - didn't want individual items to have decimal digits in price PAS-7831
                    total += Math.round(this.getPrice(x)) * x.Quantity;
                } else {
                    total += this.getPrice(x) * x.Quantity;
                }
            })
            return total;
        },
        canSeePricing() {
            return this.canSeeDealerNet || this.canSeeContractPrice;
        },
    },
    watch: {
        //update cart details whenever the summary changes - quick easy way to update whenever parts are added
        cartSummary() {
            this.getCartItems();
        },
        //update cart whenever a dealer code changes - different promos, contracts, and pricing logic for different dealers
        activeAccountId() {
            this.getCartItems();
        }
    },
    async mounted() {
        this.$store.dispatch("LOAD_CART_SUMMARY", { accountId: this.activeAccountId, userId: this.user.UserId })
        try {
            ShoppingCartService.isOrderingDisabled().then(response => {
                this.ordersDisabled = response;

                if (this.ordersDisabled) {
                    SettingsService.getAllSettings().then(response => {
                        var settings = response;
                        var settingKeys = constants.MLA_ORDERS_BLACK_SETTINGS_KEYS;
                        this.ordersDisabledNewStory = _.find(settings, (x) => x.Key == settingKeys.NEWS_STORY).Value;
                        this.ordersDisabledText = _.find(settings, (x) => x.Key == settingKeys.MESSAGE).Value;
                    });
                }
            });
        }
        catch {
            //Do nothing, allow orders
        }
    },
    created() {

    },
    methods: {

        getPartImage(oemPartCode) {
            if (this.IsNullOrUndefined(this.partDetails)) {
                return "";
            }
            var partDetails = this.partDetails.data.filter(x => x.OemPartCode === oemPartCode)[0];
            return this.IsNullOrUndefined(partDetails) || this.IsNullOrUndefined(partDetails.ImageUrl) ? this.getImage("partNoImageAvailable") : partDetails.ImageUrl;
        },

        getPrice(part) {
            // If promotion price then return it
            if (part.PromotionDiscount && this.canSeePricing) {
                return part.PromotionDiscount.DiscountedPricePerUnit;
            }
            // Show contract price if it exists and isn't equal to dealernet price or if the dealer can't see dealernet price
            else if (this.canSeeContractPrice && part.ContractPrice && (!this.canSeeDealerNet || part.ContractPrice != part.DealerNetPrice)) {
                return part.ContractPrice;
            }
            // Otherwise default to dealernet price
            else if (this.canSeeDealerNet) {
                return part.DealerNetPrice;
            }
            return "";
        },

        //Used to show the strke through price before discounted
        getPriceBeforeDiscount(part) {
            if (this.canSeeContractPrice && part.ContractPrice && (!this.canSeeDealerNet || part.ContractPrice != part.DealerNetPrice)) {
                return part.ContractPrice;
            }
            else if (part.ContractPrice < part.DealerNetPrice) {
                if (this.canSeeContractPrice) {
                    return part.ContractPrice;
                }
            }

            if (this.canSeeDealerNet) {
                return part.DealerNetPrice;
            }

            return "";
        },

        //Get part details of all parts in the cart
        getPartDetails() {
            var partCodes = this.partList.Items.slice(0, 20).map(x => x.McfPartCode);
            if (this.Any(partCodes)) {
                PartsService.GetMultiplePartDetails(this.McfCostCenterId, this.activeAccountId, this.user.UserId, partCodes).then((result) => {
                    this.partDetails = result;
                });
            }
        },

        formatCurrency(amount, formatCurrency) {
            return amount
                ? CurrencyService.formatCurrency(amount, formatCurrency)
                : "";
        },

        getPartDetailsUrl(oemPartCode) {
            return "/parts/partDetail?oemPartCode=" + oemPartCode;
        },

        getCartItems() {
            const request = {
                accountId: this.activeAccountId,
                userId: this.user.UserId,
                partListId: this.cartSummary.Id,
                promoCodes: ShoppingCartService.getAppliedPromoCodes().join(",")
            };
            ShoppingCartService.GetShoppingCart(request).then(result => {
                this.partList = result;
                this.getPartDetails();
                return result;
            })
        },

        async editPartQty(part) {
            if (part.Quantity === "" || part.Quantity < 1) {
                part.Quantity = 1;
            }
            const rq = {
                accountId: this.activeAccountId,
                userId: this.user.UserId,
                partListId: this.cartSummary.Id,
            };

            ShoppingCartService.EditShoppingCart(rq, this.partList).then(() => {
                this.$store.commit("pushTimedMessage", {
                    header: "Success",
                    message: `Quantity for ${part.OemPartCode} was successfully updated to ${part.Quantity}`,
                    IsError: false,
                    seconds: 5,
                });
            });

            await this.updateCartSummary();
        },

        async updateCartSummary() {
            const cartSummary = await ShoppingCartService.GetShoppingCartSummary({
                accountId: this.activeAccountId,
                userId: this.user.UserId,
            });
            this.$store.commit("SET_CART_SUMMARY", cartSummary);
            this.$store.dispatch("LOAD_CART_SUMMARY", { accountId: this.activeAccountId, userId: this.user.UserId });
        },

        async removeItem(part) {
            this.partList.Items = this.partList.Items.filter(x => x.Id != part.Id);
            const rq = {
                accountId: this.activeAccountId,
                userId: this.user.UserId,
                partListId: this.cartSummary.Id,
                userAudiences: this.audienceIds,
                itemIds: [part.Id],
            };
            PartListBuilderService.DeleteItems(rq).then(() => {
                this.$store.commit("pushTimedMessage", {
                    header: `Item ${part.OemPartCode} removed from cart`,
                    IsError: false,
                    seconds: 5
                });
                this.cartSummary.ItemCount -= part.Quantity;
                this.$store.commit("SET_CART_SUMMARY", this.cartSummary);
            })
                .catch(() => {
                    this.$store.commit("pushTimedMessage", {
                        header: "Error",
                        IsError: true,
                        message: `Item ${part.OemPartCode} was not removed from cart. Please try again, or go to the cart to remove the item.`,
                    });
                    // When the delete fails then get/update the cart summary and details
                    this.updateCartSummary();
                });

        },
    }
}
